export default "__VITE_ASSET__DnYhRRpe__"